import { KEY_IS_DEVOPS_PROJECT } from '../../common/constants.tsx';

const projectPropertyUrl = (projectKey: string): string =>
	`/rest/api/2/project/${projectKey}/properties/${KEY_IS_DEVOPS_PROJECT}`;

export const getIsDevOpsProject = async (projectKey: string) => {
	const url = projectPropertyUrl(projectKey);

	const response = await fetch(url);
	if (response.ok) {
		const result = await response.json();
		return result.value;
	}

	return false;
};
